<template>
  <div class="main_body livestream_page">
    <section id="hero_section">
      <div class="container">
        <navbar></navbar>
        <div class="main_logo">
          <img src="@/assets/images/Logo-011.png" alt="Logo-011.png">
        </div>
        <section class="contact_section">
          <div class="heading_section">
            <h3>Login</h3>
            <!-- <h4>Login to get access to the website.</h4> -->
          </div>
          <div class="row">
            <div class="form_wrapper">
              <form @submit.prevent="login">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label for="email">Email</label>
                    </div>
                    <div class="col-md-9">
                      <input type="email" class="form-control" required id="email" v-model="form.email"
                        placeholder="your Email" name="email">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label for="password">Password</label>
                    </div>
                    <div class="col-md-9">
                      <input type="password" class="form-control" required id="password" v-model="form.password"
                        placeholder="Password" name="password">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3 pt-3">
                  </div>
                  <div class="col-md-9">
                    <button type="submit" :disabled="isLoading"
                      class="btn btn_submit">
                      <div v-if="!isLoading">Login</div>
                      <div v-else class="loader">
                        <Loader></Loader>
                      </div>
                    </button>
                    <div class="mt-2">
                      <router-link class="redirect-link" to="/signup">Don't have an account? Signup</router-link>
                    </div>
                  </div>
                </div>

              </form>
            </div>

          </div>
        </section>

        <social-links />
      </div>
    </section>
  </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import SocialLinks from '../components/SocialLinks.vue'
export default {
  components: {
    Navbar,
    SocialLinks
  },
  name: 'Login',
  data () {
    return {
      isLoading: false,
      form: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    login () {
      this.isLoading = true
      this.$store
        .dispatch('login', this.form)
        .then(() => {
          this.isLoading = false
          if (!this.$store.getters.isEmailVerified) {
            this.$router.push('/email/verify')
          } else {
            this.$router.push('/')
          }
          this.$toast.success('Logged in successfully')
        })
        .catch((err) => {
          this.isLoading = false
          this.$helper.catchHandler(err)
        })
    }
  }
}

</script>

<style scoped>
.contact_section {
  min-height: 451px;
}
.btn_submit {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue